import type { ExtendedRouteObject } from '#/routes/types';
import loader, { id, type LoaderData, type Params } from './loader';

export default {
  id,
  path: '/profil',
  loader,
  lazy: {
    Component: async () => (await import('./index')).ProfilePage,
  },
  handle: () => ({
    breadcrumb: { label: 'Profil' },
  }),
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
